import React, { useState } from "react";
import { connect } from "react-redux";
import { createAPIKey } from "../../../services/graphs/actions";
import "./style.scss";

const CreateForm = ({ setModal, createAPIKey }) => {
  const [details, setDetails] = useState({
    APP_NAME: "",
    PLATFORM: "Alexa",
    ENVIRONMENT: "Live",
    API_KEY_U: "-",
  });
  const createKEY = async () => {
    setModal(false);
    await createAPIKey(details);
  };
  const changeDetail = (e) =>
    setDetails({ ...details, [e.target.name]: e.target.value });
  return (
    <div className="create_form_container">
      <div className="flex_container">
        <h2>Create new app</h2>
        <input
          value={details.APP_NAME}
          name="APP_NAME"
          type="text"
          onChange={changeDetail}
          placeholder="App Name"
        />
        <select
          name="PLATFORM"
          value={details.PLATFORM}
          onChange={changeDetail}
        >
          <option value="Alexa">Alexa</option>
          <option value="Google">Google</option>
        </select>
        <select
          name="ENVIRONMENT"
          value={details.ENVIRONMENT}
          onChange={changeDetail}
        >
          <option value="Live">Live</option>
          <option value="Development">Development</option>
        </select>
        <div>
          <button onClick={() => setModal(false)}>Cancel</button>
          <button onClick={createKEY}>Create</button>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { createAPIKey })(CreateForm);
